import React, { useState, Fragment } from 'react';
import { Button } from 'reactstrap';
import { UploadIconsForm } from './UploadIconsForm';
import { faPlus, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export default function UploadIconsButton({
    id,
    propertyId,
    bmb,
    parentLoadData,
    parentBmbData
}) {
    const [isUpdating, setIsUpdating] = useState(false);

    return (
        <Fragment>
            <Button
                color="primary"
                outline
                className="ml-2"
                size="xs"
                onClick={() => setIsUpdating(!isUpdating)}
            >
                <FontAwesomeIcon icon={faPlus} />
                <span> </span>
                Upload Icon
            </Button>

            {isUpdating && (
                <UploadIconsForm
                    id={id}
                    toggleModal={() => {
                        setIsUpdating(!isUpdating);
                    }}
                    formLabel="Upload Icons"
                    visible={isUpdating}
                    propertyId={propertyId}
                    bmb={bmb}
                    parentLoadData={parentLoadData}
                    parentBmbData={parentBmbData}
                />
            )}
        </Fragment>
    );
}

